module.exports = __webpack_public_path__ + "static/android-icon-192x192-8e509095148422dfb1c8b8a49ed56f7c.png";